import { create } from 'zustand';

type PageHelpState = {
  pageTitle: string;
  /** When the screen has tabs or steps, this is the active tab/step label. */
  tabTitle: string | null;
  modalOpen: boolean;
  setPageHelpContext: (pageTitle: string, tabTitle?: string | null) => void;
  clearPageHelpContext: () => void;
  openPageHelpModal: () => void;
  closePageHelpModal: () => void;
};

/** Modal headline: tab/step when present, otherwise page title. */
export function getPageHelpDisplayTitle(pageTitle: string, tabTitle: string | null): string {
  if (tabTitle) {
    return tabTitle;
  }
  return pageTitle.trim() || 'This page';
}

export const usePageHelpStore = create<PageHelpState>((set) => ({
  pageTitle: '',
  tabTitle: null,
  modalOpen: false,
  setPageHelpContext: (pageTitle, tabTitle = null) =>
    set({ pageTitle, tabTitle: tabTitle ?? null }),
  clearPageHelpContext: () => set({ pageTitle: '', tabTitle: null }),
  openPageHelpModal: () => set({ modalOpen: true }),
  closePageHelpModal: () => set({ modalOpen: false }),
}));
